import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AddInternShipModel } from 'common/models/page-models/Student Internship List/Add intership/add-internship-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AddInternshipFormWidgetService } from 'common/widget/intership Listing/addInternship-widget.service';

@Injectable({
    providedIn: 'root'
})
export class AddInternshipFormResolver extends FormResolverService<AddInternShipModel> {
    constructor(
        protected fs: AddInternshipFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel, meta, widget) {
    //     dataModel['studentfeedback'] = '';
    //     return dataModel;
    // }

    
    
}
